import { createElement } from 'react';
import activeHtml from 'react-active-html';

// import fs from 'fs';
// import path from 'path';

// const appDirectory = fs.realpathSync(process.cwd());
export const universalActiveHtml = (html, componentMap) => {
  if (process.env.BUILD_TARGET === 'server') {
    const xmldom = require('xmldom');
    activeHtml.DOMParser = new xmldom.DOMParser();
  }

  return activeHtml(html, componentMap);
};

if (!process.env.RAZZLE_CMS_SITE) {
  throw new Error(
    'The RAZZLE_CMS_SITE environment variable is required but was not specified.'
  );
}

export function getSiteRoutes() {
  // Load routes.js from the matching sites directory if available.
  const routes = require(`../../sites/${
    process.env.RAZZLE_CMS_SITE
  }/routes.js`);
  return routes;
}

export function formatPrice(price, countryCode, currencyCode) {
  if (!countryCode || !currencyCode) {
    return price;
  }
  return new Intl.NumberFormat(countryCode, {
    style: 'currency',
    currency: currencyCode
  }).format(price);
}

export function wrapMultiline(string, splitBy = '\n', wrapWith = 'p') {
  const parts = string.split(splitBy);

  return parts.map(part => createElement(wrapWith, [], part));
}

export const analytics =
  typeof window !== 'undefined' && window.analytics ? window.analytics : {};

export const getCookieDomain = () =>
  process.env.RAZZLE_COOKIE_DOMAIN
    ? process.env.RAZZLE_COOKIE_DOMAIN
    : '.formlabs.com';

export const handleRedirect = (res, status) => {
  // Server-side, update status codes and redirect if necessary
  if (res) {
    if (status.location) {
      res.redirect(status.code, status.location);
    } else {
      res.status(status.code);
    }
  } else {
    // client-side redirect
    if (status.location) {
      const redirectLocation = status.location;
      return { redirectLocation };
    }
  }
};

// Sort array by values respecting the natural locale specific order
export const sortWithLocale = (items, locale) =>
  items.sort((a, b) =>
    a.text.localeCompare(b.text, locale, { ignorePunctuation: true })
  );
